module.exports = __webpack_public_path__ + "static/media/recharges.76ae1078.svg";